import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=f044a1d4&"
import script from "./LabelInput.vue?vue&type=script&lang=js&"
export * from "./LabelInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&id=f044a1d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports